import { registeredTabsHandlers } from '@/global/components/view-layouts/tabs-layout/common/registered-tabs-handlers'
import { registeredTableHandlers } from '@/global/components/view-layouts/tabs-layout/config/registered-table-handlers'
import { isObject, cloneDeep } from '@/global/utils/utils'
import { dateService, FORMATS } from '@/global/services/date'
import { api } from '@/global/services/api'

export default {
  methods: {
    onShowLeasingDetails (event) {
      const { setFormData } = registeredTabsHandlers?.leasing || {}
      const { data } = event || {}
      const clonedData = cloneDeep(data)
      const { showDetails, setDetailsTitle } = this.blockConfig || {}
      const appendToDetailsTitle = clonedData.contract_number || this.$t('fleet/vehicle.details')
      const detailsTitle = this.$t('fleet/vehicle_leasing.leasings') + ' - ' + appendToDetailsTitle

      if (typeof setFormData === 'function' && data && isObject(data)) {
        // convert dates for correct display
        clonedData.start_date = clonedData?.start_date ? dateService.formatCustom(data.start_date, FORMATS.isoDate, FORMATS.date) : null
        clonedData.expiry_date = clonedData?.expiry_date ? dateService.formatCustom(data.expiry_date, FORMATS.isoDate, FORMATS.date) : null
        clonedData.vehicle_pickup_date = clonedData?.vehicle_pickup_date ? dateService.formatCustom(data.vehicle_pickup_date, FORMATS.isoDate, FORMATS.date) : null

        this.leasingDetailsTitle = detailsTitle
        setDetailsTitle?.(detailsTitle)
        setFormData(clonedData)
      }

      showDetails?.()
      this.showLeasingTable = false
      this.showLeasingDetails = true
    },

    onLeasingActivation (event) {
      const { status, id, contract_number: contractNumber } = event?.data || {}
      if (!id) {
        return
      }
      const title = status ? this.$t('fleet/vehicle.leasing_deactivation_title') : this.$t('fleet/vehicle.leasing_activation_title')
      this.$set(this.informationDialogConfig, 'title', title + ' - ' + (contractNumber || '/'))
      this.$set(this.informationDialogConfig, 'message', status ? this.$t('fleet/vehicle.leasing_deactivation_message') : this.$t('fleet/vehicle.leasing_activation_message'))
      this.$set(this.informationDialogConfig, 'callbackFn', () => this.leasingActivation(event))
      this.$set(this.informationDialogConfig, 'openDialog', true)
    },

    async leasingActivation (event) {
      try {
        const { id, status } = event?.data || {}
        const { fetchData } = registeredTableHandlers?.leasing || {}
        const formData = new FormData()
        formData.append('_method', 'PATCH')
        formData.append('status', status ? 'false' : 'true')

        await api('fleet').post(`vehicle-leasing-status/${id}`, formData)

        this.$set(this.informationDialogConfig, 'openDialog', false)
        if (typeof fetchData === 'function') {
          fetchData()
        }
      }
      catch (exception) {
        console.error(exception)
      }
    },

    onLeasingDelete (event) {
      const { id, contract_number: contractNumber } = event?.data || {}
      if (!id) {
        return
      }

      const title = this.$t('fleet/vehicle.leasing_delete_title')
      this.$set(this.informationDialogConfig, 'title', title + ' - ' + (contractNumber || '/'))
      this.$set(this.informationDialogConfig, 'message', this.$t('fleet/vehicle.leasing_delete_message'))
      this.$set(this.informationDialogConfig, 'callbackFn', () => this.leasingDelete(event))
      this.$set(this.informationDialogConfig, 'openDialog', true)
    },

    async leasingDelete (event) {
      try {
        const { id } = event?.data || {}
        const { fetchData } = registeredTableHandlers?.leasing || {}

        await api('fleet').delete(`vehicle-leasing/${id}`)

        this.$set(this.informationDialogConfig, 'openDialog', false)
        if (typeof fetchData === 'function') {
          fetchData()
        }
      }
      catch (exception) {
        console.error(exception)
      }
    },

    async leasingRemoveImageCallback (event) {
      try {
        const { module, route } = event?.removeApiConfig || {}
        const { uuid: imageUuid, tabKey } = event?.file || {}
        const { index } = event || {}
        const { fetchData } = registeredTableHandlers?.[tabKey] || {}

        if (module && route && imageUuid) {
          await api(module).delete(route + imageUuid)
          this.imagesPreviewDialogConfig.images = this.imagesPreviewDialogConfig.images.filter((_, i) => i !== index)
          if (typeof fetchData === 'function') {
            fetchData()
          }
        }
      }
      catch (exception) {
        console.error(exception)
      }
    },

    async leasingRemovePdfCallback (event) {
      try {
        const { module, route } = event?.removeApiConfig || {}
        const { uuid: pdfUuid, tabKey } = event?.file || {}
        const { index } = event || {}
        const { fetchData } = registeredTableHandlers?.[tabKey] || {}

        if (module && route && pdfUuid) {
          await api(module).delete(route + pdfUuid)
          this.filesPreviewDialogConfig.files = this.filesPreviewDialogConfig.files.filter((_, i) => i !== index)
          if (typeof fetchData === 'function') {
            fetchData()
          }
        }
      }
      catch (exception) {
        console.error(exception)
      }
    }
  }
}
